import { render, staticRenderFns } from "./RouteBreadcrumb.vue?vue&type=template&id=1c612264&scoped=true"
import script from "./RouteBreadcrumb.vue?vue&type=script&lang=js"
export * from "./RouteBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./RouteBreadcrumb.vue?vue&type=style&index=0&id=1c612264&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c612264",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c612264')) {
      api.createRecord('1c612264', component.options)
    } else {
      api.reload('1c612264', component.options)
    }
    module.hot.accept("./RouteBreadcrumb.vue?vue&type=template&id=1c612264&scoped=true", function () {
      api.rerender('1c612264', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/utils/RouteBreadcrumb.vue"
export default component.exports